namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;
	import psga = apigateway.client;
	import psgm = apigateway.models;

    export interface IClaimService {
		getAccumulator(memberNumber: string, date: Date): angular.IPromise<psgm.ClaimAccumulatorModel[]>;
    }

    @Service('app', 'claimService')
	@Inject('$q', 'ClaimV1Api')
    export class ClaimService implements IClaimService {
        constructor(
			private $q: angular.IQService,
			private claimApi: psga.ClaimV1Api,
        ){}

		getAccumulator(memberNumber: string, date: Date): angular.IPromise<psgm.ClaimAccumulatorModel[]> {
			return this.$q.when(this.claimApi.getByMemberNumber(memberNumber, moment(date)).then((response) => {
				response.data.data.forEach(cam => {
					cam.endDate = <moment.Moment><unknown>cam.endDate?.toDate();
					cam.startDate = <moment.Moment><unknown>cam.startDate?.toDate();
				});
				return response.data.data;
			}));
		}
	}
}